import processCalcTotalsRebuildReasonAppliedAdjs from './processCalcTotalsRebuildReasonAppliedAdjs'
//----------------------------------------------------------
// process calc totals rebuild reasons applied adjs harness
//----------------------------------------------------------
export default function processCalcTotalsRebuildReasonAppliedAdjsHarness({
  adjs,
  category,
  character,
  add_only = true,
} = {}) {
  //-----------------------
  // defensive check parms
  //-----------------------
  if (!adjs || !category || !character) {
    console.error('processCalcTotalsRebuildReasonAppliedAdjsHarness: missing required parms')
    return { adjs, category, character }
  }
  //-----------------------------------------------------------------------------------
  // get unique adj names affected (set auto removes dupes where '...' provides array)
  //-----------------------------------------------------------------------------------
  const affectedAdjs = [...new Set(adjs.map((adj) => adj.name))]
  //--------------------------------
  // process each affected adj once
  //--------------------------------
  affectedAdjs.forEach((adjName) => {
    //-------------
    // set payload
    //-------------
    const payload = {
      category: category, // 'skill' | 'ability' | 'characteristic'
      type: adjName,
      data: character[`${category}_adjs`].filter((adj) => adj.name === adjName),
    }
    //----------------------------------------------------------------------------------------------
    // process calc totals rebuild reason adjs (flag adding only so no need to clear existing adjs)
    //--------------------------------------------------------------------------------------------------
    // NB: when this function called from adjs view - logic requires existing adjs to be cleared first)
    //--------------------------------------------------------------------------------------------------
    character = processCalcTotalsRebuildReasonAppliedAdjs({
      payload,
      character,
      add_only: add_only,
    })
  })
  //--------------------------------------------------------------
  // return mutated objects for clarity (optional use by callers)
  //--------------------------------------------------------------
  return character
}
